if (document.querySelector('.article-content')) {

    let headlines = document.querySelectorAll('.article-content h2');
        let list = document.createElement('ol');
        list.classList.add('table-of-contents-list');
        headlines.forEach(headline => {
            let listItem = document.createElement('li');
            let listLink = document.createElement('a');
            listLink.href = `#${headline.textContent.replace(/\s+/g, '-').toLowerCase()}`;
            listLink.classList.add('text-decoration-none');
            headline.id = headline.textContent.replace(/\s+/g, '-').toLowerCase();
            listLink.textContent = headline.textContent;
            listItem.appendChild(listLink);
            list.appendChild(listItem);
        });
        document.querySelector('.table-of-contents-list-wrapper').appendChild(list);
    }